import Container from './Container.jsx'

export default function PageHeader({ eyebrow, title, subtitle, children }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10">
      <div className="pointer-events-none absolute inset-0 bg-grid [mask-image:linear-gradient(to_bottom,white,transparent)]" />
      <div className="pointer-events-none absolute inset-0 glow" />
      <Container className="relative py-16 text-center sm:py-20">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        {/* The top margin belongs to the gap under the eyebrow, so it goes
            when the eyebrow does — otherwise a header without one opens on
            20px of empty space. */}
        <h1 className={`mx-auto max-w-3xl text-4xl font-extrabold sm:text-5xl ${eyebrow ? 'mt-5' : ''}`}>{title}</h1>
        {subtitle && <p className="mx-auto mt-4 max-w-2xl text-lg text-slate-400">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </Container>
    </section>
  )
}
